import { Component, OnInit, Input, OnDestroy} from '@angular/core';
import { CnsltnReqModel, ConsultRequestService, QuotationService, CnsltnType} from '../../../../services/index';
import { Router, ActivatedRoute } from '@angular/router';
declare var moment:any;

@Component({
  selector: 'cnsltn-list-item-fwdr',
  templateUrl: 'cnsltn-list-item-fwdr.html',
})


export class CnsltnListItemFwdr {
  @Input() cnsltnReq: CnsltnReqModel;
  @Input() index: number;

  isShowCnsltnFwdr:boolean = false;
  
  getStusNmByCd:Function = QuotationService.getStusNmByCd;
  
  constructor(private router: Router, private consultRequestService:ConsultRequestService){

  }


  detail(reqNo:string){
    this.router.navigate(['/quotation/consult-detail', reqNo]);
  }

  getLocalDtmStr(dtm:string):string {
		return moment(dtm, "YYYY/MM/DD HH:mm").add(9, 'hour').format('YYYY/MM/DD HH:mm:ss');
  }

  ngOnDestroy(){
    this.cnsltnReq = null;
  }

  closeShowCnsltnFwdr(){
    this.isShowCnsltnFwdr = false;
  }

  getCnsltnType(reqTp:number, transTp:number):CnsltnType{
    return this.consultRequestService.getCnsltnType(reqTp, transTp);
  } 
}


// WEBPACK FOOTER //
// ./src/app/containers/quotation/forwarder/cnsltn-list/cnsltn-list-item-fwdr.ts